<h2 mat-dialog-title>{{ data.title || data.filename }}</h2>

<mat-dialog-content class="dialog-content">
  <ng-container *ngIf="isImage()">
    <div class="preview-viewport">
      <div class="image-container" (mousedown)="handleMouseDown($event)" (mousemove)="handleMouseMove($event)"
        (mouseup)="handleMouseUp()" (mouseleave)="handleMouseUp()"
        [style.cursor]="zoomLevel > 100 ? (isDragging ? 'grabbing' : 'grab') : 'default'">
        <img #imageRef [src]="data.url" alt="Preview" class="preview-image"
          [style.transform]="'scale(' + (zoomLevel / 100) + ') rotate(' + rotation + 'deg) translate(' + position.x + 'px, ' + position.y + 'px)'"
          [style.transform-origin]="'center center'" draggable="false" />
      </div>

      <!-- Navigation Buttons for Multiple Attachments -->
      <button class="nav-btn prev-btn" *ngIf="hasMultipleAttachments() && data.currentIndex !== undefined && data.currentIndex > 0" (click)="prevAttachment()">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button class="nav-btn next-btn" *ngIf="hasMultipleAttachments() && data.currentIndex !== undefined && data.attachments && data.currentIndex < data.attachments.length - 1" (click)="nextAttachment()">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>

    <!-- Thumbnails navigation -->
    <div class="thumbnails-container" *ngIf="hasMultipleAttachments()">
      <div *ngFor="let file of data.attachments; let idx = index" 
           class="thumbnail-item" 
           [class.active]="idx === data.currentIndex"
           (click)="showAttachmentAtIndex(idx)">
        <ng-container [ngSwitch]="getFileType(file)">
          <img *ngSwitchCase="'image'" [src]="getAttachmentFullUrl(file)" class="thumbnail-img" />
          <div *ngSwitchCase="'pdf'" class="thumbnail-fallback pdf-fallback">
            <mat-icon>picture_as_pdf</mat-icon>
          </div>
          <div *ngSwitchCase="'doc'" class="thumbnail-fallback word-fallback">
            <mat-icon>description</mat-icon>
          </div>
          <div *ngSwitchCase="'xls'" class="thumbnail-fallback excel-fallback">
            <mat-icon>table_view</mat-icon>
          </div>
          <div *ngSwitchDefault class="thumbnail-fallback generic-fallback">
            <mat-icon>insert_drive_file</mat-icon>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="controls-container">
      <!-- All Controls in a single row -->
      <div class="all-controls-row">
        <div class="zoom-controls-group">
          <button mat-icon-button (click)="zoomOut()" [disabled]="zoomLevel <= 25">
            <mat-icon>zoom_out</mat-icon>
          </button>

          <div class="zoom-slider-group">
            <input type="range" [value]="zoomLevel" (input)="handleZoomChange($any($event.target).valueAsNumber)"
              min="25" max="500" step="25" class="zoom-slider-input" />
            <span class="zoom-percentage">{{ zoomLevel }}%</span>
          </div>

          <button mat-icon-button (click)="zoomIn()" [disabled]="zoomLevel >= 500">
            <mat-icon>zoom_in</mat-icon>
          </button>
        </div>

        <div class="action-buttons-group">
          <button mat-icon-button (click)="rotate()">
            <mat-icon>refresh</mat-icon>
          </button>

          <button mat-button (click)="reset()">
            Reset
          </button>

          <button mat-icon-button (click)="toggleFullscreen()">
            <mat-icon>{{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
          </button>

          <button mat-flat-button color="primary" (click)="download()" *ngIf="data.url">
            Download
          </button>
          <button mat-button mat-dialog-close>
            Close
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isHtml || isPdf() || isWord() || isExcel()">
    <!-- Combined for iframe preview, added isExcel() -->
    <div class="preview-viewport">
      <div class="html-preview-container"> <!-- Reusing html-preview-container for generic iframe -->
        <iframe [src]="safeImageUrl" frameborder="0" class="html-iframe"></iframe>
      </div>

      <!-- Navigation Buttons for Multiple Attachments -->
      <button class="nav-btn prev-btn" *ngIf="hasMultipleAttachments() && data.currentIndex !== undefined && data.currentIndex > 0" (click)="prevAttachment()">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button class="nav-btn next-btn" *ngIf="hasMultipleAttachments() && data.currentIndex !== undefined && data.attachments && data.currentIndex < data.attachments.length - 1" (click)="nextAttachment()">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>

    <!-- Thumbnails navigation -->
    <div class="thumbnails-container" *ngIf="hasMultipleAttachments()">
      <div *ngFor="let file of data.attachments; let idx = index" 
           class="thumbnail-item" 
           [class.active]="idx === data.currentIndex"
           (click)="showAttachmentAtIndex(idx)">
        <ng-container [ngSwitch]="getFileType(file)">
          <img *ngSwitchCase="'image'" [src]="getAttachmentFullUrl(file)" class="thumbnail-img" />
          <div *ngSwitchCase="'pdf'" class="thumbnail-fallback pdf-fallback">
            <mat-icon>picture_as_pdf</mat-icon>
          </div>
          <div *ngSwitchCase="'doc'" class="thumbnail-fallback word-fallback">
            <mat-icon>description</mat-icon>
          </div>
          <div *ngSwitchCase="'xls'" class="thumbnail-fallback excel-fallback">
            <mat-icon>table_view</mat-icon>
          </div>
          <div *ngSwitchDefault class="thumbnail-fallback generic-fallback">
            <mat-icon>insert_drive_file</mat-icon>
          </div>
        </ng-container>
      </div>
    </div>
    
    <div class="controls-container">
      <div class="all-controls-row">
        <div class="action-buttons-group">
          <button mat-icon-button (click)="toggleFullscreen()">
            <mat-icon>{{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
          </button>

          <button mat-flat-button color="primary" (click)="download()" *ngIf="data.url">
            Download
          </button>

          <button mat-button mat-dialog-close>
            Close
          </button>
        </div>
      </div>
    </div>
  </ng-container>

</mat-dialog-content>

<mat-dialog-actions align="end" *ngIf="!isHtml && !isImage() && !isPdf() && !isWord() && !isExcel()">
  <!-- Exclude Excel from this action bar -->
  <button mat-button mat-dialog-close>Close</button>
  <button mat-flat-button color="primary" (click)="download()" *ngIf="data.url">
    Download
  </button>
</mat-dialog-actions>
